import { TranRecordModel } from "./tran-record.model"

export class GetResponseModel {
    Trans: TranRecordModel
    blnIsEstimate: boolean
    intClinicNo: number

    constructor(
        Trans: TranRecordModel,
        blnIsEstimate: boolean,
        intClinicNo: number
    ) {
        this.Trans = Trans
        this.blnIsEstimate = blnIsEstimate
        this.intClinicNo = intClinicNo
    }
}